import BaseReducer from "./BaseReducer";

class AuthorisationModalReducer extends BaseReducer {
  domain = "Modal";
  type = "Authorisation";

  initialState = {
    open: false,
    comments: "",
    maxLength: 750,
  };
}

const reducer = new AuthorisationModalReducer();

export default reducer;
